export default "__VITE_ASSET__0f11bba0__"